const fetchWithRetries = ( maxRetries, fetchFunction, onSuccess) => {
    let attempts = 0;

    const attemptFetch = () => {
        fetchFunction().then(response => {
            if (response.success) {
                onSuccess(response.payload);

                //if succeeded on retry, log the name of the function that succeeded
                if (attempts > 0) {
                    console.log(`Succeeded ${fetchFunction.name} on attempt ${attempts + 1}/${maxRetries}`);
                }
                

            } else {
                //log the name of the function that failed
                console.log(`Failed to fetch data with ${fetchFunction.name}. Retrying... (${attempts + 1}/${maxRetries})`);
                attempts++;
                if (attempts < maxRetries) {
                    attemptFetch();
                }
            }
        });
    };

    attemptFetch();
};

export default fetchWithRetries;